import React from 'react'
import { Switch } from 'react-router'
import { Route } from 'react-router-dom'
import App from './App'
import Error404 from './Error404'
import Router from 'react-router-dom/Router'
import createBrowserHistory from 'history/createBrowserHistory'
import LegalNotice from './components/LegalNotice'
import PrivacyPolicy from './components/PrivacyPolicy'
import CookiesPolicy from './components/CookiesPolicy'
import { injectIntl, defineMessages } from 'react-intl'
import { withRouter } from 'react-router'
import Distribuidor from './components/Distribuidor'

defineMessages({
    _ROUTE_HOME: {
        id: '_ROUTE_HOME',
        description: '_ROUTE_HOME',
        defaultMessage: '/'
    },
    _ROUTE_AVISO_LEGAL: {
        id: '_ROUTE_AVISO_LEGAL',
        description: '_ROUTE_AVISO_LEGAL',
        defaultMessage: '/aviso-legal'
    },
    _ROUTE_POLITICA_DE_PRIVACIDAD: {
        id: '_ROUTE_POLITICA_DE_PRIVACIDAD',
        description: '_ROUTE_POLITICA_DE_PRIVACIDAD',
        defaultMessage: '/politica-de-privacidad'
    },
    _ROUTE_POLITICA_DE_COOKIES: {
        id: '_ROUTE_POLITICA_DE_COOKIES',
        description: '_ROUTE_POLITICA_DE_COOKIES',
        defaultMessage: '/politica-de-cookies'
    },
    _ROUTE_DISTRIBUTOR: {
        id: '_ROUTE_DISTRIBUTOR',
        description: '_ROUTE_DISTRIBUTOR',
        defaultMessage: '/distribuidor'
    }
})
class Routes extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <Switch>
                <Route exact path={this.props.intl.formatMessage({ id: '_ROUTE_HOME' })} component={App} />
                <Route exact path={this.props.intl.formatMessage({ id: '_ROUTE_AVISO_LEGAL' })} component={LegalNotice} />
                <Route exact path={this.props.intl.formatMessage({ id: '_ROUTE_POLITICA_DE_PRIVACIDAD' })} component={PrivacyPolicy} />
                <Route exact path={this.props.intl.formatMessage({ id: '_ROUTE_POLITICA_DE_COOKIES' })} component={CookiesPolicy} />
                <Route exact path={this.props.intl.formatMessage({ id: '_ROUTE_DISTRIBUTOR' })} component={Distribuidor} />
                <Route component={Error404} />
            </Switch>
        )
    }
}
export default withRouter(injectIntl(Routes))



// WEBPACK FOOTER //
// ./src/Routes.js